import homeView from './index'
import searchView from './search'
import bookView from './book'

import model from './services/model'

export default {
  path: 'hotel',
  component: homeView,
  name: 'Private/Hotel',
  redirect: { name: 'Private/Hotel/Search', params: { Currency: 'EUR' } },
  children: [
    {
      path: 'search/:Currency',
      component: searchView,
      name: 'Private/Hotel/Search',
      beforeEnter (to, from, next) {
        if (to.params.Currency !== model.params.currency) {
          model.params.currency = to.params.Currency
          model.results = []
          next()
        } else next()
      }
    },
    {
      path: 'book/:Result/:Category/:Meal',
      component: bookView,
      name: 'Private/Hotel/Book'
    }
  ],
  beforeEnter (to, from, next) {
    if (!model.initDataLoaded) model.init().then(res => next())
    else next()
  }
}
